<template>
    <div class="banner bng-casino-banner-categories">
        <img
            :src="isMobilePhone ? '/static/banners/casino-home-banner/desktop/races.jpg' : '/static/banners/casino-home-banner/desktop/races.jpg'"
        />
        <div class="content">
            <div>{{"components.common.banners.casino-banners.races.msg1" | translate}}</div>
            <ul>
                <li v-for="item in $t('components.common.banners.casino-banners.races.msg3')">{{item}}</li>
            </ul>
        </div>
        <div class="detailed">
            <router-link :to="{ name: 'races' }">{{"components.common.banners.casino-banners.races.play" | translate}}</router-link>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'casino-banner-races',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.cashback && this.client.bonus.cashback.percent;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/casino-banners/races.vue